import React, { useCallback, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, message } from 'antd';
import PropTypes from 'prop-types';

import OnTraccrSwitch from '../common/inputs/OnTraccrSwitch';
import { togglePermissions } from './state/settings.actions';

const FORMS_TYPE_PREFIX = 'FORMS_TYPE_';

export default function FormTypePermissions({ roleName }) {
  const dispatch = useDispatch();
  const [updating, setUpdating] = useState(false);

  const formTypes = useSelector((state) => state.forms.types || []);
  const rolePerms = useSelector((state) => state.settings.positions?.[roleName] || []);

  const enabledFormTypeIds = useMemo(() => {
    const ids = new Set();
    rolePerms.forEach((perm) => {
      if (perm.startsWith(FORMS_TYPE_PREFIX)) {
        const id = parseInt(perm.slice(FORMS_TYPE_PREFIX.length), 10);
        if (!Number.isNaN(id)) ids.add(id);
      }
    });
    return ids;
  }, [rolePerms]);

  const handleToggle = useCallback(
    async (formTypeId) => {
      try {
        setUpdating(true);
        const permission = `${FORMS_TYPE_PREFIX}${formTypeId}`;
        const isEnabled = enabledFormTypeIds.has(formTypeId);
        await dispatch(togglePermissions({
          position: roleName,
          permission,
          enabled: !isEnabled,
        }));
      } catch (err) {
        message.error('Error updating form type permission');
      } finally {
        setUpdating(false);
      }
    },
    [roleName, enabledFormTypeIds, dispatch],
  );

  if (!formTypes || formTypes.length === 0) {
    return (
      <div style={{ margin: '0px 10px 10px 10px', color: '#888' }}>
        No form types available
      </div>
    );
  }

  return (
    <div style={{ margin: '0px 10px 10px 10px' }}>
      {formTypes.map((formType) => {
        const isEnabled = enabledFormTypeIds.has(formType.id);
        return (
          <Row
            key={formType.id}
            style={{
              padding: '8px 0',
              borderBottom: '1px solid #f0f0f0',
            }}
          >
            <Col span={20}>
              <span style={{ fontSize: '14px' }}>{formType.name}</span>
            </Col>
            <Col span={4} style={{ textAlign: 'right' }}>
              <OnTraccrSwitch
                value={isEnabled}
                disabled={updating}
                onChange={() => handleToggle(formType.id)}
              />
            </Col>
          </Row>
        );
      })}
    </div>
  );
}

FormTypePermissions.propTypes = {
  roleName: PropTypes.string.isRequired,
};
